if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.form.removeEventListener('submit', this.onSubmitHandlerBound);
      this.onSubmitHandlerBound = this.onSubmitHandler.bind(this);
      this.form.addEventListener('submit', this.onSubmitHandlerBound);
    }

    get cart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    async onSubmitHandler(evt) {
      if (evt) {
        evt.preventDefault();
        evt._handledByProductForm = true;
      }

      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const cartEl = this.cart;
      let errorOccurred = false;

      try {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;

        const formData = new FormData(this.form);

        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          try {
            const sections = cartEl.getSectionsToRender().map((section) => section.id);
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
            if (typeof cartEl.setActiveElement === 'function') {
              cartEl.setActiveElement(document.activeElement);
            }
          } catch (secErr) {
            console.warn('Could not extract sections to render:', secErr);
          }
        }

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add.js';

        const res = await fetch(cartAddUrl, config);
        const response = await res.json();

        if (response.status && response.status !== 200) {
          errorOccurred = true;
          this.handleErrorMessage(response.description || response.message || 'Error adding product to cart');

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', 'true');
            const leftText = this.submitButton.querySelector('.btn-text-left') || this.submitButton.querySelector('span');
            if (leftText) leftText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              if (cartEl && typeof cartEl.renderContents === 'function') cartEl.renderContents(response);
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(response);
        } else if (cartEl && typeof cartEl.open === 'function') {
          cartEl.open();
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
      } catch (err) {
        errorOccurred = true;
        console.error('Add to cart failed:', err);
        this.handleErrorMessage(err.message || 'Failed to add item to cart');
      } finally {
        if (this.submitButton) {
          this.submitButton.classList.remove('loading');
          if (!errorOccurred) this.submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
        if (cartEl && cartEl.classList.contains('is-empty')) {
          cartEl.classList.remove('is-empty');
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Fallback delegated submission for dynamically cloned Swiper slides or unupgraded forms
document.addEventListener('submit', function (evt) {
  if (evt._handledByProductForm) return;
  const form = evt.target;
  if (!form || !form.matches('.quick-add form, form[data-type="add-to-cart-form"]')) return;

  evt.preventDefault();
  const submitButton = form.querySelector('[type="submit"]');
  const spinner = form.querySelector('.loading-overlay__spinner');

  if (submitButton) {
    if (submitButton.getAttribute('aria-disabled') === 'true') return;
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
  }
  if (spinner) spinner.classList.remove('hidden');

  const idInput = form.querySelector('[name=id]');
  if (idInput) idInput.disabled = false;

  const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const formData = new FormData(form);

  if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
    try {
      const sections = cartEl.getSectionsToRender().map((s) => s.id);
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    } catch (e) {}
  }

  const cartAddUrl = (window.routes && window.routes.cart_add_url) || (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add.js';

  fetch(cartAddUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/javascript',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
    .then((r) => r.json())
    .then((response) => {
      if (response.status && response.status !== 200) {
        console.error('Cart add error:', response);
        return;
      }
      if (cartEl && typeof cartEl.renderContents === 'function') {
        cartEl.renderContents(response);
      } else if (cartEl && typeof cartEl.open === 'function') {
        cartEl.open();
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch((err) => {
      console.error('Cart add fetch error:', err);
    })
    .finally(() => {
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      if (spinner) spinner.classList.add('hidden');
      if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
    });
});
